// extracted by mini-css-extract-plugin
module.exports = {"desktopMinWidth":"1024","tabletMaxWidth":"1023","mobileMaxWidth":"767"};